import axios, { HttpStatusCode } from "axios";
import { StatusMessageResponse } from "../../../common/interfaces/status-message-response";

export async function deleteEmitPurchaseOrder(id: string, token: string): Promise<StatusMessageResponse> {
  try {
    const response = await axios.delete(process.env.REACT_APP_BASE_URL+'/ordemcompra-emit/'+id, 
      {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }
    );

    const res = response.data; // Supondo que a resposta de criação seja retornado pelo backend
    return res;
  } catch (error) {
    return {
      statusCode: HttpStatusCode.InternalServerError,
      message: 'Falha ao deletar de uma ordem de compra',
    }
  }
}